import Mode from 'dashboard/components/GraphCanvasV2/behaviors/mode';
import GraphEvent, { GraphEventType } from 'dashboard/components/GraphCanvasV2/events/graph-event';

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
export default class ModeChangedEvent extends GraphEvent<null> {
  public static type = GraphEventType.GraphModeChanged;
  public graphTarget: Mode;

  constructor(event: null, graphTarget: Mode) {
    super(GraphEventType.GraphModeChanged, event);
    this.graphTarget = graphTarget;
  }
}
